/**
 * Le fil entre la page et la scène en volume.
 *
 * ⭐ POURQUOI PAS UN CONTEXTE REACT : ce qui traverse ici change à SOIXANTE
 * IMAGES PAR SECONDE pendant une animation. Le faire passer par un état React
 * relancerait le rendu de tout l'arbre du canvas à chaque image, et la scène
 * `memo`ïsée qui protège la cuisson de l'environnement serait la première à
 * sauter. Une valeur mutable plus un abonnement, c'est exactement le besoin, et
 * ça ne coûte rien.
 *
 * ⛔ LES VALEURS PAR DÉFAUT SONT LES VALEURS D'ARRIVÉE, jamais celles de départ.
 * Si l'orchestration ne démarre pas — script bloqué, erreur, module qui ne se
 * charge pas — la scène doit être dans son état FINI, gravure comprise. Une
 * valeur de départ par défaut donnerait un socle vierge pour toujours, sans
 * qu'aucune erreur ne soit levée nulle part.
 */

type Ecoute = () => void

export type EtatScene = {
  /** Remplissage de la gravure du socle, de 0 à 1. */
  gravure: number
  /** Avancée du récit au défilement, de 0 à 1. */
  avancee: number
}

export const etat: EtatScene = { gravure: 1, avancee: 0 }

const ecoutes = new Set<Ecoute>()

export function regler(changement: Partial<EtatScene>) {
  Object.assign(etat, changement)
  for (const prevenir of ecoutes) prevenir()
}

export function ecouter(prevenir: Ecoute): () => void {
  ecoutes.add(prevenir)
  return () => {
    ecoutes.delete(prevenir)
  }
}
